/*
 * @description: 接口定义
 * @Author: Jay
 * @Date: 2021-07-23 09:34:40
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-29 15:28:35
 */

import request from '@/utils/request'
// import { isToken } from "@/utils/operate";

/*
请求方式
import { Test,get } from "../api/api";

 Test().then((res)=>{
      console.log(res)
    })

export function get(data) {
    return request({
        url: "data/api.auth.address/get",
        method: "POST", // 请求方式
        data: data, // 数据
        token: isToken()
    })
 }
*/
// 备案号索取
export function banben(data) {
    return request({
        url: "api/index/banben",
        method: "POST",
        data: data,
    })
}

//  导航栏目获取
export function nav(data) {
    return request({
        url: "api/index/nav",
        method: "POST",
        data: data,
    })
}

//  首页
export function reHome(data) {
    return request({
        url: "api/index/index",
        method: "POST",
        data: data,
    })
}

// 联系我们
export function contactus(data) {
    return request({
        url: "api/index/contactus",
        method: "POST",
        data: data,
    })
}

// 企业简介
export function aboutus(data) {
    return request({
        url: "api/index/aboutus",
        method: "POST",
        data: data,
    })
}

//科普巡展
export function roadshow(data) {
    return request({
        url: "api/index/roadshow",
        method: "POST",
        data: data,
    })
}

// 互动体验
export function interactive(data) {
    return request({
        url: "api/index/interactive",
        method: "POST",
        data: data,
    })
}

// 科普殿堂
export function palace(data) {
    return request({
        url: "api/index/palace",
        method: "POST",
        data: data,
    })
}

// 科普标本室
// export function sample(data) {
//     return request({
//         url: "api/index/sample",
//         method: "POST",
//         data: data,
//     })
// }

// 科普文创
export function cultural(data) {
    return request({
        url: "api/index/cultural",
        method: "POST",
        data: data,
    })
}

// 自然博物馆
export function getSample(data) {
    return request({
        url: "api/index/sample",
        method: "POST",
        data: data,
    })
}

// 逛博物馆
export function stroll(data) {
    return request({
        url: "api/index/stroll",
        method: "POST",
        data: data,
    })
}

// 宝藏鉴赏
export function baozang(data) {
    return request({
        url: "api/index/baozang",
        method: "POST",
        data: data,
    })
}

// 客服获取 左下角
export function getKefu(data) {
    return request({
        url: "api/index/kefu",
        method: "POST",
        data: data,
    })
}

// 科普践行
export function aboutcoupe(data) {
    return request({
        url: "api/index/aboutcoupe",
        method: "POST",
        data: data,
    })
}